module.exports = __webpack_public_path__ + "img/slide-2-mob.e1181fd.webp";